<script setup>
import { nextTick } from "vue";
import { useCollectionStore } from "../../../stores/collection";
import { useFilterStore } from "../../../stores/filter";
import Icon from "../../Common/Icon.vue";
import CollectionItem from "./CollectionItem.vue";

const emit = defineEmits(["close", "close-modal"]);
const props = defineProps({
  open: {
    type: Boolean,
    required: true,
  },
});

const collectionStore = useCollectionStore();
const filterStore = useFilterStore();

function deleteCollection(index) {
  collectionStore.deleteCollection(index);

  // Close collection overlay if there are no collection items
  if (!collectionStore.hasAnyCollection) {
    emit("close");
  }
}

async function onApply(collection) {
  window.klarnachrichten.trackMatomoEvent("collection-apply");
  filterStore.applyCollectionFilters(collection.filters);
  await nextTick();

  collectionStore.setActiveCollectionId(collection.id);
  emit("close-modal");
}
</script>

<template>
  <div
    :class="props.open ? 'translate-x-0' : '-translate-x-full'"
    class="absolute transition-transform left-0 top-0 size-full bg-light flex flex-col"
  >
    <button
      type="button"
      @click="emit('close')"
      class="flex items-center shrink-0 gap-x-6 font-bold px-10 lg:px-16 py-5 lg:py-8 border-b border-dark/10"
    >
      <Icon name="caret-down" class="size-4 rotate-90 shrink-0" />
      <span v-t="'filter.collection.headline'"></span>
    </button>

    <div class="relative h-full overflow-y-auto">
      <div class="absolute left-0 top-0 size-full">
        <CollectionItem
          v-for="collection in collectionStore.collections"
          :key="collection.id"
          :item="collection"
          @delete="deleteCollection(collection.id)"
          @rename="collectionStore.renameCollection(collection.id, $event)"
          @apply="onApply(collection)"
        />
      </div>
    </div>
  </div>
</template>
